// extracted by mini-css-extract-plugin
module.exports = {"section":"FreeQuote_section___mgs4"};